import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getBlogsQuery } = useBlogsProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full table-fixed border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[7%]">
                SR No.
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">
                Name
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[30%]">
                Email
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">
                Phone
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">
                Company
              </th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">
                Service
              </th>
            </tr>
          </thead>

          <tbody>
            {getBlogsQuery?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="border border-gray-300 px-2 py-2 break-words text-center whitespace-normal w-[6%]">
                  <Label
                    className="mb-0 text-black text-[15px]"
                    label={`${index + 1}.`}
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words break-words whitespace-normal w-[10%]">
                  <Label
                    className="mb-0 text-black text-[15px]"
                    label={item.name}
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words break-words whitespace-normal w-[30%]">
                  <Label className="mb-0 text-[15px]" label={item.email} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={item.phone} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={item.company} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={item.services} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  );
}
